/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

export type Tier = typeof Tier[keyof typeof Tier];


export const Tier = {
  tier_1: 'tier_1',
  tier_2: 'tier_2',
  tier_3: 'tier_3',
} as const;
